import React from 'react'
import igQrIcon from 'assets/img/qrcode-logos/ig.png'

import { QRCode } from 'components/QRCode'

import cm from './IgQrDmUrl.module.css'

export function IgQrDmUrl({ url }: { url?: string }) {
  if (!url) return null

  return (
    <div className={cm.wrapper}>
      <QRCode
        id="ig-qr-dm-url"
        renderAs="PNG"
        size={168}
        value={url}
        img={{
          img_big: igQrIcon,
        }}
        imgSize={{
          width: 16,
          height: 16,
        }}
      />
    </div>
  )
}
